<template>
  <div class="customer-list-wrapper">
    <div class="customer-list-info">
      <div class="loader" v-if="(errorLogs.length === 0 && noLogs === false) || !asyncDone">
        <h3 style="position: relative;top: 125px;width: 500px;left: -80px;">{{asyncText}}</h3>
      </div>
      <p class="card-text text-center text-danger mb-3 font-weight-bold" v-if="noLogs && asyncDone">There are no
        logs in the database to show here.</p>
    </div>
    <div v-if="errorLogs.length" class="customer-table">
      <table id="datatable" class="table table-striped table-bordered table-responsive w-100">
        <thead>
        <tr>
          <th>API Path</th>
          <th>Error Code</th>
          <th>Error Message</th>
          <th>From</th>
          <th>Created</th>
          <th style="width: 300px">View Payload</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(log, index) in errorLogs" :key="index">
          <td>{{ log.apiPath }}</td>
          <td>{{log.errorCode}}</td>
          <td>{{ log.errorMessage }}</td>
          <td>{{ log.from || '' }}</td>
          <td class="sort-date">{{ formattedDate(log.createdAt) }}</td>
          <td style="width: 300px">
            <button class="btn btn-primary btn-sm mr-2" @click="viewLogs(log)"><i class="fa fa-eye"></i></button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="row mt-2">
      <div class="col-md-12 text-center">
        <span class="pull-left mt-2"><b>Page Number: </b> {{ pageNumber + 1 }}</span>
        <button class="btn btn-link btn-sm btn-round" :disabled="pageNumber === 0" v-on:click="prevPage">
          Prev
        </button>
        <button class="btn btn-link btn-sm btn-round" :disabled="errorLogs.length < pageSize" v-on:click="nextPage">
          Next
        </button>
      </div>
    </div>
    <div class="view-api-log-modal">
      <div class="modal fade" tabindex="-1" role="dialog" id="viewApiLogsModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">Job: {{selectedLog.id}}</h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h6>Input data for this job:</h6>
              <code>
                <ol>
                  <li v-for="(value, propertyName) in selectedLog.payload" :key="propertyName">
                    <template>
                      <span>{{propertyName}}</span> : <b>{{value}}</b>
                    </template>
                  </li>
                </ol>
              </code>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {db} from "@/firebase/init";
import dateMixin from "@/mixins/dateMixin";
import _ from "lodash";
export default {
  name: "apiErrorList",
  mounted() {
    this.fetchApiLogs()
  },
  mixins: [dateMixin],
  data() {
    return {
      errorLogs: [],
      selectedLog: {},
      pageSize: 10,
      noLogs: false,
      pageNumber: 0,
    }
  },
  computed: {
    asyncDone() {
      return this.$store.getters["async/state"];
    },
    asyncText() {
      return this.$store.getters["async/text"];
    },
    last () {
      return (this.errorLogs.length > 0) ? this.errorLogs[this.errorLogs.length-1] : null;
    },
    first () {
      return (this.errorLogs.length > 0) ? this.errorLogs[0] : null;
    }
  },
  methods: {
    async fetchApiLogs () {
      console.log('inside fetch')
      this.errorLogs = [];
      this.noLogs = false;
      this.pageNumber = 0;
      try {
        const ref = await db.collection('apiErrorLogs')
            .orderBy("createdAt", "desc")
            .limit(this.pageSize)
            .get()
        if (ref.empty === true) {
          this.noLogs = true;
        }
        ref.forEach(doc => {
          this.errorLogs.push({
            id: doc.id,
            ...doc.data()
          })
        });
      } catch (err) {
        console.error(err);
        // Show error message to the customer for 5 sec
        await this.$store.dispatch("alert/update", {
          type: "danger",
          message: err.name,
          show: true
        });

        setTimeout(() => {
          this.$store.dispatch("alert/showUpdate", {show: false});
        }, 5000);
      }

    },
    async nextPage() {
      if (this.last) {
        this.pageNumber ++;
        await this.$store.dispatch("async/stateUpdate", {state: false});
        try {
          const ref = await db.collection('apiErrorLogs')
              .orderBy("createdAt", "desc")
              .startAfter(this.last.createdAt)
              .limit(this.pageSize)
              .get()
          if (ref.empty === true) {
            this.noLogs = true;
          }
          this.errorLogs = [];
          ref.forEach(doc => {
            this.errorLogs.push({
              id: doc.id,
              ...doc.data()
            })
          });
          await this.$store.dispatch("async/stateUpdate", {state: true});
        } catch (err) {
          console.error(err);
          // Show error message to the customer for 5 sec
          await this.$store.dispatch("alert/update", {
            type: "danger",
            message: err.name,
            show: true
          });
          await this.$store.dispatch("async/stateUpdate", {state: true});

          setTimeout(() => {
            this.$store.dispatch("alert/showUpdate", {show: false});
          }, 5000);
        }
      }
    },
    async prevPage(){
      if (this.first) {
        this.pageNumber--;
        await this.$store.dispatch("async/stateUpdate", {state: false});
        try {
          const ref = await db.collection('apiErrorLogs')
              .orderBy("createdAt", "desc")
              .endBefore(this.first.createdAt)
              .limit(this.pageSize)
              .get()
          if (ref.empty === true) {
            this.noLogs = true;
          }
          this.errorLogs = [];
          ref.forEach(doc => {
            this.errorLogs.push({
              id: doc.id,
              ...doc.data()
            })
          });
          await this.$store.dispatch("async/stateUpdate", {state: true});
        } catch (err) {
          console.error(err);
          // Show error message to the customer for 5 sec
          await this.$store.dispatch("alert/update", {
            type: "danger",
            message: err.name,
            show: true
          });
          await this.$store.dispatch("async/stateUpdate", {state: true});

          setTimeout(() => {
            this.$store.dispatch("alert/showUpdate", {show: false});
          }, 5000);
        }
      }
    },
    async getApiErrorLogs() {
      this.errorLogs = []
      this.pageNumber = 0;
      const ref= await db.collection('apiErrorLogs').get()
      if (ref.size) {
        ref.forEach(el => {
          this.errorLogs.push({id: el.id, ...el.data()})
        })
      }
    },
    viewLogs (log) {
      this.selectedLog = _.cloneDeep(log)
      if (log.from !== 'Server') {
        this.selectedLog.payload= log.payload ? JSON.parse(log.payload) : '';
      }

      console.log(this.selectedLog)
      /* eslint-disable */
      $("#viewApiLogsModal").modal("show");
      $(document).ready(function () {
        $(".modal-backdrop").appendTo(".view-api-log-modal");
      });
      /* eslint-enable */
    },
  }
}
</script>

<style scoped>
code {
  background: #f4f4f4;
  border: 1px solid #ddd;
  border-left: 3px solid #2954fa;
  color: #666;
  page-break-inside: avoid;
  font-family: monospace;
  font-size: 12px;
  line-height: 1.6;
  margin-bottom: 1.6em;
  max-width: 100%;
  overflow: auto;
  padding: 1em 1.5em;
  display: block;
  word-wrap: break-word;
}
code .info{
  color: #376c4f;
}
code .danger{
  color: #cf363e;
}
</style>
